"use client";

import SolarLocationPage from "@/components/locations/solar-location-page";
import { getLocationLandingConfig } from "@/data/location-pages";

const config = getLocationLandingConfig("huelva");

export default function PlacasSolaresHuelvaPage({ locale }: { locale: string }) {
  return <SolarLocationPage locale={locale} id="huelva" config={config} />;
}
